module.exports = __webpack_public_path__ + "static/img/servicer.ee07cd.svg";